import { logPile } from "./src/logPile";

// The site's ad-hoc logger: still prints, and now also leaves a breadcrumb so
// a later capture's timeline shows what the app was doing.
export const logger = (...params: (string | any)[]) => {
  console.log(params);
  logPile.addBreadcrumb({
    category: "log",
    message: params.map((p) => (typeof p === "string" ? p : safe(p))).join(" ").slice(0, 2000),
  });
};

const safe = (v: unknown) => {
  try {
    return JSON.stringify(v) ?? String(v);
  } catch {
    return String(v);
  }
};
